export const HOME_TITLE = 'yeim log | Home'
